module.exports = "//static.hsappstatic.net/signup-ui-lego/static-1.12080/images/google-contacts-sync.svg"